// extracted by mini-css-extract-plugin
export default {"container":"Journeys_container__UZzCs","search":"Journeys_search__Ud5Cy"};